import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  FormControl,
  Grid,
  Typography,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  MenuItem,
  OutlinedInput,
  Paper,
  Select
} from "@mui/material"
import React, { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { makeStyles } from "@mui/styles"


import ConfirmDialog from "../../components/ConfirmDialog"

import fileBrowser from "../../icons/file-browser.svg"
import { ReactComponent as Alert } from "../../icons/alert-red.svg"

import { ReactComponent as ChevronExpandDown } from "../../assets/icons/chevron-expand-down.svg"
import { ReactComponent as ChevronExpandUp } from "../../assets/icons/chevron-expand-up.svg"
import { ReactComponent as TrashIcon } from "../../assets/images/portfolio/trash-alt.svg"

function StylePaper(props) {
  return (
    <Paper component="div" sx={{ padding: "0m 1.5rem 1.5rem 1.5rem", height: "460px", border: "1px solid #CED4DA", overflow: "auto" }}>
      {props.children}
    </Paper>
  )
}

function NoData() {
  const { t } = useTranslation();
  return (
    <TableRow>
      <TableCell colSpan={5} sx={{ borderBottom: "0!important"}}>
        <Box
          textAlign="center"
          sx={{ fontWeight: 300, flexFlow: "column" }}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Box>
            <img src={fileBrowser} alt="browser" />
          </Box>
          <Box>
            <Typography color="#A0A0A0">{t("label.nodata")}</Typography>
          </Box>
        </Box>
      </TableCell>
    </TableRow>
  )
}

const ConfirmAddMemberDialog = (props) => {
  const { t } = useTranslation()

  const useStyles = makeStyles({
    unactiveSvg: {
      "& > path": {
        fill: "#6B6B6B"
      }
    },
    activeSvg: {
      "& > path": {
        fill: "#6B6B6B"
      }
    }
  })

  const classes = useStyles()

  const handleClose = () => {
    props.setDialogValue(false)
  }

  const [isFirstLoaded, setIsFistLoaded] = React.useState(false)

  const handleRequestSort = (key, direction = "asc") => {
    let tmpList = JSON.parse(JSON.stringify(filteredList))
    if (key !== "category") {
      tmpList.sort(function (a, b) {
        if (direction === "asc") {
          return a[key].toLowerCase().localeCompare(b[key].toLowerCase())
        }else {
          return b[key].toLowerCase().localeCompare(a[key].toLowerCase())
        }
      })
    }else {
      tmpList = handlePreSelectedCategory(tmpList)
      tmpList.sort(function (a, b) {
        if (direction === "asc") {
          return a[key].toLowerCase().localeCompare(b[key].toLowerCase())
        }else {
          return b[key].toLowerCase().localeCompare(a[key].toLowerCase())
        }
      })
    }
    setFilteredList(tmpList)
  }

  const [list, setList] = React.useState([])
  const [selectedList, setSelectedList] = React.useState([])
  const [filteredList, setFilteredList] = React.useState([])
  const [selectedMemberDetailList, setSelectedMemberDetailList] = React.useState([])
  
  const doSetSelectedList = () => {
    let tmpFilteredList = list.filter(item => selectedList.includes(item.formEvaluateID))
    setFilteredList(tmpFilteredList)
    setIsFistLoaded(true)
  }

  // handle select input change
  const handleChangeCategory = (value, serial, formEval) => {
    let data = { memberSerial: serial, selectCategory: value, memberFormEvaluate: formEval }
    let tmpSelected = [...selectedMemberDetailList]
    let isExisted = tmpSelected.findIndex(item => item.memberFormEvaluate === formEval)
    if (isExisted > -1){
      tmpSelected = tmpSelected.map(item => {
        if (formEval === item.memberFormEvaluate) { 
          return { memberSerial: item.memberSerial, selectCategory: data.selectCategory, memberFormEvaluate: formEval  }
        }else {
          return item
        }
      })
    }else {
      tmpSelected.push(data)
    }
    setSelectedMemberDetailList(tmpSelected)
  }

  // map category name on select input
  const mapRowSelectedCategory = (member) => {
    let isExisted = selectedMemberDetailList.filter(x => x.memberFormEvaluate === member).map(y => y.selectCategory)
    return isExisted.length > 0 ? isExisted[0] : ""
  }

  const [preSelectedCategory, setPreSelectedCategory] = React.useState("")
  
  const handlePreSelectedCategory = (list) => {
    let tmpFilteredList = JSON.parse(JSON.stringify(list))
    tmpFilteredList = tmpFilteredList.map(item => {
      return {
        ...item,
        category: mapRowSelectedCategory(item.formEvaluateID)
      }
    })
    return tmpFilteredList
  }

  const [openConfirmRemoveDialog, setOpenConfirmRemoveDialog] = React.useState(false)
  const [removeMember, setRemoveMember] = React.useState("")
  const [currentRemoveMember, setCurrentRemoveMember] = React.useState("")
  const handleOpenConfirmRemoveMember = (member) => {
    setOpenConfirmRemoveDialog(true)
    setRemoveMember(member.formEvaluateID)
    setCurrentRemoveMember(member.fullNameEN)
  }

  const handleRemoveMember = () => {
    let tmpFilteredList = filteredList.filter(item => item.formEvaluateID !== removeMember)
    setFilteredList(tmpFilteredList)
    setOpenConfirmRemoveDialog(false)
  }


  const [goalCategoryOptions, setGoalCategoryOptions] = React.useState([])
  
  // map category name passed from parent
  const mapGoalCategoryOptions = (currentCategory) => {
    let isExisted = goalCategoryOptions.filter(x => x.serial === currentCategory).map(y => y.name)
    return isExisted.length > 0 ? isExisted[0] : "-"
  }

  const [isFormValid, setIsFormValid] = React.useState(false)
  const validateForm = () => {
    const checkCategory = (data) => {
      return selectedMemberDetailList.findIndex(item => item.memberSerial === data)
    } 
    let isValid = filteredList.every(list => checkCategory(list.serial) > -1)
    setIsFormValid(isValid)
  }

  const handleConfirmAdd = () => {
    props.formSubmit(selectedMemberDetailList)
  }

  // useEffect
  useEffect(() => {
    if (props?.memberList?.length > 0) {
      setList(props.memberList)
    }
    if (props?.selectedList?.length > 0) {
      setSelectedList(props.selectedList)
    }
  }, [props.memberList, props.selectedList])

  useEffect(() => {
    doSetSelectedList()
  }, [list, selectedList, props.open])
  useEffect(() => {
    if (isFirstLoaded) {
      handleRequestSort("category", "asc")
    }    
 }, [isFirstLoaded])
  // set pre-select category
  useEffect(() => {
    if (preSelectedCategory && preSelectedCategory !== "") {
      let tmpResult = []
      filteredList.forEach(list => {
        list?.empCategories.forEach(cat => {
          if (cat?.value === preSelectedCategory) {
            tmpResult.push({ memberSerial: list.serial, selectCategory: cat?.serial, memberFormEvaluate: list?.formEvaluateID })
          }
        })
      })
      setSelectedMemberDetailList(tmpResult)
    }
  }, [preSelectedCategory, filteredList])
  
  useEffect(() => {
    validateForm()
  }, [selectedMemberDetailList, filteredList]) 

  useEffect(() => {
    if (props?.goalCategoryOptions && props?.goalCategoryOptions?.length > 0) setGoalCategoryOptions(props.goalCategoryOptions)
  }, [props.goalCategoryOptions])

  useEffect(() => {
    if (props?.preSelectedCategory?.kpi_goal_template_category_id) setPreSelectedCategory(props.preSelectedCategory.kpi_goal_template_category_id)
  }, [props.preSelectedCategory])
  // end useEffect
  
  return (
    <React.Fragment>
      <Dialog
        disableEscapeKeyDown={true}
        open={props.open}
        maxWidth="lg"
        fullWidth={true}
        PaperProps={{ sx: { p: "30px" } }}
      >
        <DialogTitle sx={{p: "0px 0px 10px 0!important"}}>
          <Box sx={{display: "flex", justifyContent: "start", alignItems: "center", p: 0}}>
            <Typography fontSize="24px" fontWeight="600" sx={{ p: 0 }}>{ props?.type !== "cascade" ? t("corporateGoal.label.selectedGoalMembers") : t("corporateGoal.label.cascadeGoalTo")}</Typography>
          </Box>
        </DialogTitle>
        <Divider/>
        <DialogContent sx={{ p: "10px 0" }} component="div">
          <DialogContentText id="alert-dialog-description" style={{ display: 'flex', flexFlow: 'column' }}>
            <Grid container>
              <Grid item display="flex">
                <Typography color="#939393" fontSize="16px" fontWeight="500">{t("label.total")}:</Typography><Typography color="#939393" fontSize="16px" fontWeight="400" sx={{ ml: 1 }}>{ filteredList.length }</Typography>
              </Grid>
            </Grid>
            { 
              !isFormValid &&
              <Grid container>
                <Grid item display="flex" alignItems="center">
                  <Alert />
                  <Typography color="#CC6058" fontSize="16px" fontWeight="500" sx={{ ml: 1 }}>{`${t("corporateGoal.label.memberTable.alertGoalCategory1")} “ ${mapGoalCategoryOptions(preSelectedCategory)} ” ${t("corporateGoal.label.memberTable.alertGoalCategory2")}`}</Typography>
                </Grid>
              </Grid>
            }
            <Grid container mt={2}>
              <Grid item xs={12} md={12} lg={12} xl={12}>
                <TableContainer component={StylePaper}>
                  <Table sx={{ width: "100%" }} aria-label="member table" stickyHeader>
                    <TableHead sx={{ borderBottom: "1px solid #e0e0e0" }}>
                      <TableRow>
                        <TableCell align="left" sortDirection="asc" display="flex">
                          <Typography
                            fontWeight={500}
                            fontSize={16}
                            lineHeight="24px"
                            color="#A0A0A0"
                            sx={{ display: "flex" }}
                            component={'span'}
                          >
                            {t("corporateGoal.label.memberTable.code")}
                            <Box sx={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                              <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => handleRequestSort("code", "asc")} className={classes.activeSvg}/>
                              <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => handleRequestSort("code", "desc")} className={classes.activeSvg}/>
                            </Box>
                          </Typography>
                        </TableCell>
                        <TableCell align="left" sortDirection="asc" display="flex" >
                          <Typography
                            fontWeight={500}
                            fontSize={16}
                            lineHeight="24px"
                            color="#A0A0A0"
                            sx={{ display: "flex" }}
                            component={'span'}
                          >
                            {t("corporateGoal.label.memberTable.name")}
                            <Box sx={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                              <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => handleRequestSort("fullNameEN", "asc")} className={classes.activeSvg}/>
                              <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => handleRequestSort("fullNameEN", "desc")} className={classes.activeSvg}/>
                            </Box>
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography
                            fontWeight={500}
                            fontSize={16}
                            lineHeight="24px"
                            color="#A0A0A0"
                            sx={{ display: "flex" }}
                            component={'span'}
                          >
                            {t("corporateGoal.label.memberTable.position")}
                            <Box sx={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                              <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => handleRequestSort("empSubName", "asc")} className={classes.activeSvg}/>
                              <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => handleRequestSort("empSubName", "desc")} className={classes.activeSvg}/>
                            </Box>
                          </Typography>
                        </TableCell>
                        <TableCell
                          align="left"
                          className="clickable"
                        >
                          <Typography
                            fontWeight={500}
                            fontSize={16}
                            lineHeight="24px"
                            sx={{ color: "#A0A0A0", display: "flex" }}
                            component={'span'}
                          >
                            {t("corporateGoal.label.memberTable.team")}
                            <Box sx={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                              <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => handleRequestSort("empName", "asc")} className={classes.activeSvg}/>
                              <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => handleRequestSort("empName", "desc")} className={classes.activeSvg}/>
                            </Box>
                          </Typography>
                        </TableCell>
                        <TableCell
                          align="left"
                          className="clickable"
                        >
                          <Typography
                            fontWeight={500}
                            fontSize={16}
                            lineHeight="24px"
                            sx={{ color: "#A0A0A0", display: "flex" }}
                            component={'span'}
                          >
                            {t("corporateGoal.label.memberTable.goalCategory")}
                            <Box sx={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                              <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => handleRequestSort("category", "asc")} className={classes.activeSvg}/>
                              <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => handleRequestSort("category", "desc")} className={classes.activeSvg}/>
                            </Box>
                          </Typography>
                        </TableCell>
                        <TableCell />
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {filteredList.length > 0 ? (
                        filteredList.map((row) =>
                          (
                            <TableRow
                              key={row.formEvaluateID}
                            >
                              <TableCell align="left" sx={{ width: "80px" }}>
                                <Typography  fontSize={16} sx={{ color: "#404349"}} fontWeight="400">
                                  { row.code }
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Box display="flex">
                                  <Box
                                    display="flex"
                                    alignItems="flex-start"
                                    justifyContent="start"
                                    sx={{ flexFlow: "column" }}
                                  >
                                    <Typography
                                      variant="h4"
                                      fontWeight="500"
                                      fontSize={18}
                                      color="#404349"
                                    >
                                      {row.fullNameEN}
                                    </Typography>
                                    <Typography
                                      variant="h5"
                                      fontSize={16}
                                      color="#404349"
                                      fontWeight="400"
                                    >
                                      {row.fullNameTH}
                                    </Typography>
                                  </Box>
                                </Box>
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontSize={16} color="#404349" fontWeight={400}>
                                  { row.empSubName }
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontSize={16} color="#404349" fontWeight={400}>
                                  { row.empName } 
                                </Typography>
                              </TableCell>
                              <TableCell align="left" sx={{width: "220px"}}>
                                <FormControl sx={{ m: 1, minWidth: 80, mt: 0, ml: 0 }} fullWidth error={mapRowSelectedCategory(row.formEvaluateID) === ""}>
                                  <Select
                                    displayEmpty
                                    id={row.formEvaluateID}
                                    value={mapRowSelectedCategory(row.formEvaluateID)}
                                    onChange={(val) => { handleChangeCategory(val.target.value, row.serial, row.formEvaluateID) }}
                                    input={<OutlinedInput size="small" />}
                                    sx={{ width: "200px" }}
                                  >
                                    {row?.empCategories.map((option, idx) => {
                                      return <MenuItem key={idx} value={option.serial}><Typography style={{fontWeight: 400, fontSize: '16px', color: '#404349'}}>{option.name}</Typography></MenuItem>
                                    })}
                                  </Select>
                                </FormControl>
                              </TableCell>
                              <TableCell align="left" sx={{width: "50px"}}>
                                <Button onClick={() => handleOpenConfirmRemoveMember(row)}>
                                  <TrashIcon />
                                </Button>
                              </TableCell>
                            </TableRow>
                          )
                        )
                      ) : (
                        <NoData />
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 0 }}>
          <Button onClick={() => handleClose()} size="large" variant="outlined" color="black" sx={{ width: '144px', mr: 8 }} style={{textTransform: 'none'}}>{t(`label.back`)}</Button>
          <Button onClick={() => handleConfirmAdd()} size="large" variant="contained" sx={{ minWidth: '144px', width: "fit-content", ml: 8 }} style={{textTransform: 'none'}} disabled={filteredList.length === 0 || !isFormValid}>{ props?.type !== "cascade" ? t(`corporateGoal.label.addMembers`) : t(`corporateGoal.label.cascadeGoal`)}</Button>
        </DialogActions>
      </Dialog>
      <ConfirmDialog open={openConfirmRemoveDialog} warning={true} doConfirm={handleRemoveMember} setValue={setOpenConfirmRemoveDialog} title={t("corporateGoal.label.dialog.removeMemberTitle")} text={`${t("corporateGoal.label.dialog.removeMemberText")} “${currentRemoveMember}” ?`} cancel={t("corporateGoal.label.dialog.cancelDelete")} confirm={t("corporateGoal.label.dialog.confirmDelete")} />
    </React.Fragment>
  );
};
export default ConfirmAddMemberDialog;
